export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7794.4e88af27.jpg";